import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PropertyFavorite } from 'app/models/property-favorite';
import { stringType } from 'aws-sdk/clients/iam';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CognitoUtil } from './cognito.service';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {
  public static _API_ENDPOINT = environment.marketingAPIEndpoint;
  public static _API_ENDPOINT_TRIPOD = environment.apiEndPoint;

  constructor(private http: HttpClient, private router: Router, private cognitoUtil: CognitoUtil) { }


  createOptions() {
    this.cognitoUtil.refresh();
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Host': 'localhost',
        'Authorization': localStorage.getItem('AccessToken'),
      })
    };
  }

  createOptionsTripod() {
    this.cognitoUtil.refresh();
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('AWSCreds'),
        'Identity': localStorage.getItem('CognitoId'),
        'Sub': localStorage.getItem('CognitoSub')
      })
    };
  }


  getFavorites() {
    return this.http.get<PropertyFavorite[]>(FavoriteService._API_ENDPOINT + 'property/favorite', this.createOptions())
    .pipe(
      catchError(this.handleError),
      map((response) => <PropertyFavorite[]>(response))
    );
  }

  getActiveConcession(yardiKey: string) {
    return this.http.get(FavoriteService._API_ENDPOINT_TRIPOD + `account/GetActiveConcessionForPropertyFavorite?yardiKey=${yardiKey}`, { ...this.createOptionsTripod(), responseType: 'text' as const} )
    .pipe(
      catchError(this.handleError),
      map((response) => <string>(response))
    );
  }

  getActiveMFConcession(yardiKey: string, yardiUnitCode: string) {
    return this.http.get<string>(FavoriteService._API_ENDPOINT_TRIPOD + `account/GetActiveMFConcessionForPropertyFavorite?yardiKey=${yardiKey}&yardiUnitCode=${yardiUnitCode}`, this.createOptionsTripod())
    .pipe(
      catchError(this.handleError),
      map((response) => <string>(response))
    );
  }

  createFavorite(favorite: PropertyFavorite) {
    return this.http.post<string>(FavoriteService._API_ENDPOINT + 'property/favorite', favorite, this.createOptions())
    .pipe(
      catchError(this.handleError),
      map((response) => <string>(response))
    );
  }

  deleteFavorite(yardiKey: string, yardiUnitCode: string) {
    return this.http.delete<string>(FavoriteService._API_ENDPOINT + `property/favorite?yardiKey=${yardiKey}&yardiUnitCode=${yardiUnitCode}`, this.createOptions())
    .pipe(
      catchError(this.handleError),
      map((response) => <string>(response))
    );
  }

  handleError(error: HttpErrorResponse | any) {
    let errMsg: string;
    if (error.status === 403) {
        this.router.navigate(['/logout']);
    }
    if (error.error  instanceof ErrorEvent) {
        const body = error.error;
        if (body.message) {
            errMsg = error.error.message;
        } else {
            const err = body;
            errMsg = `${error.statusText || ''} ${err}`;
        }
    } else {
        errMsg = error.message ? error.message : error.toString();
        if (errMsg.length === 0) {
            errMsg = 'There was an unknown error.  Please try again later';
        }
    }
    return throwError(errMsg);
  }






}
